let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("1NbSo")).then(() => parcelRequire('i5xYK'));